@if (visible) {
  <div class="update-banner" role="status" aria-live="polite" @bannerAnimation>
    <div class="update-banner__progress" [style.width.%]="progressPercent"></div>

    <div class="update-banner__content">
      <div class="update-banner__icon" aria-hidden="true">
        <i class="fa fa-cloud-download"></i>
        <span class="update-banner__icon-pulse"></span>
      </div>

      <div class="update-banner__text">
        <span class="update-banner__title">Nueva versión disponible</span>
        <span class="update-banner__subtitle">
          Se aplicará automáticamente en
          <strong class="update-banner__countdown">{{ remainingLabel }}</strong>
          @if (latestVersion?.version) {
            · {{ latestVersion?.version }}
          }
        </span>
      </div>

      <button
        type="button"
        class="update-banner__action"
        (click)="updateNow()"
        aria-label="Actualizar el sistema ahora"
      >
        <i class="fa fa-rocket" aria-hidden="true"></i>
        <span>Actualizar ahora</span>
      </button>
    </div>
  </div>
}
